import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import {
    FETCH_FILTER_LIST,
    UPDATE_FILTER_SHOW_STATUS,
    UPDATE_SHOW_ALL,
    UPDATE_SETTING_UPDATED,
    UPDATE_DEFAULT_SHOW_STATUS,
    SAVE_FILTER_SETTINGS,
} from "../actions/filterSettingActions";

const intialState = {
    fetchedFiltersList: false,
    topic: [],
    platform: [],
    publication: [],
    location: [],
    language: [],
    platformsActive: [],
    languagesActive: [],
    locationsActive: [],
    publicationsActive: [],
    publicationsActiveObject: {},
    platformsObject: {},
    languagesObject: {},
    locationsObject: {},
    topicsAndSubtopics: [],
    topicsObject: {},
    topicsTree: [],
    google_trends_countries: [],
    trending_videos_counties: [],
    twitter_trends_countries: [],
    filterSettingsUpdated: {
        status: false,
        topic: [],
        platform: [],
        publication: [],
        location: [],
        language: [],
        twitter_trends_countries: [],
        trending_videos_counties: [],
    },
    filterListLoading: false,
    filterListError: false,
    masterPublications: [],
    masterLocations: [],
    masterLanguages: [],
    masterPlatforms: [],
    twitter_countries: [],
    youtube_countries: [],
    disableCancel: false,
};

const filterYoutubeTrendsCountry = (twitterCoutry, youtubeTrendsCountry) => {
    let updatedList = [];

    for (let i = 0; i < youtubeTrendsCountry.length; i++) {
        if (
            twitterCoutry.findIndex(function (wizard) {
                return wizard.entity_id === youtubeTrendsCountry[i].id;
            }) > -1
        ) {
            updatedList.push(
                twitterCoutry[
                    twitterCoutry.findIndex(function (wizard) {
                        return wizard.entity_id === youtubeTrendsCountry[i].id;
                    })
                ],
            );
        }
    }

    return updatedList;
};

const filterTwitterTrendsCountry = (twitterCoutry, twitterTrendsCountry) => {
    let updatedList = [];

    for (let i = 0; i < twitterTrendsCountry.length; i++) {
        if (
            twitterCoutry.findIndex(function (wizard) {
                return wizard.entity_id === twitterTrendsCountry[i].id;
            }) > -1
        ) {
            updatedList.push(
                twitterCoutry[
                    twitterCoutry.findIndex(function (wizard) {
                        return wizard.entity_id === twitterTrendsCountry[i].id;
                    })
                ],
            );
        }
    }

    return updatedList;
};
const filterSettingReducer = (state = intialState, action) => {
    switch (action.type) {
        case isFulfilled(FETCH_FILTER_LIST): {
            // console.log("firstaction", action.payload);
            const filterList = {
                topic: action.payload.data.filters.keywords?.filter((ac) => ac.entity_name !== "OWNNED_PAGE" && ac.entity_name !== "competitors") || [],
                language: action.payload.data.filters.languages || [],
                location: action.payload.data.filters.locations || [],
                platform: action.payload.data.filters.platforms || [],
                publication: action.payload.data.filters.publications || [],
                google_trends_countries: action.payload.data.filters.google_trends_countries || [],
                trending_videos_counties:
                    filterYoutubeTrendsCountry(
                        action.payload.data.filters.trending_videos_counties,
                        action.payload.data.masterFilters.trends_supported_country.youtube,
                    ) || [],
                twitter_trends_countries:
                    filterTwitterTrendsCountry(
                        action.payload.data.filters.twitter_trends_countries,
                        action.payload.data.masterFilters.trends_supported_country.twitter,
                    ) || [],

                masterLocations: action.payload.data.masterFilters.masterLocations || [],
                masterLanguages: action.payload.data.masterFilters.masterLanguages || [],
                masterPlatforms: action.payload.data.masterFilters.masterPlatforms || [],
            };

            const platformsObject = {};
            filterList.masterPlatforms.forEach((x) => {
                platformsObject[x.id] = x;
            });

            const languagesObject = {};
            filterList.masterLanguages.forEach((x) => {
                languagesObject[x.id] = x;
            });

            const locationsObject = {};
            filterList.masterLocations.forEach((x) => {
                locationsObject[x.id] = x;
            });

            const keywordsMap = {};
            let keywordsActiveLength = 0;
            if (!window.location.href.includes("data-usage/analytics")) {
                action.payload.data.filters.keywords.forEach((k) => {
                    keywordsMap[k.entity_id] = k.is_active;
                    if (k.is_active) keywordsActiveLength++;
                });
            }
            const topicsAndSubtopics = window.location.href.includes("data-usage/analytics")
                ? action.payload.QueryfilterState
                : action.payload.data.filters.topicsAndSubtopics.filter((t) => keywordsMap[t.topic_id] === 1);

            const activeFilters = getFilterList(filterList);
            const { topicsObject, topicsTree } = getTopicsTree(topicsAndSubtopics);
            return {
                ...state,
                ...filterList,
                ...activeFilters,
                platformsObject,
                languagesObject,
                locationsObject,
                // keywordsMap,
                keywordsActiveLength,
                topicsAndSubtopics,
                topicsObject,
                topicsTree,
                filterListError: false,
                filterListLoading: false,
                filterSettingsUpdated: intialState.filterSettingsUpdated,
                fetchedFiltersList: true,
            };
        }
        case isPending(SAVE_FILTER_SETTINGS):
            return {
                ...state,
                disableCancel: true,
            };
        case isRejected(SAVE_FILTER_SETTINGS):
            return {
                ...state,
                disableCancel: false,
            };
        case isFulfilled(SAVE_FILTER_SETTINGS):
            return {
                ...state,
                disableCancel: false,
            };

        case isPending(FETCH_FILTER_LIST):
            return { ...state, filterListError: false, filterListLoading: true };
        case isRejected(FETCH_FILTER_LIST):
            return { ...state, filterList: {}, filterListError: true, filterListLoading: false };

        case UPDATE_FILTER_SHOW_STATUS: {
            let { filterName, d } = action.payload;

            let updatedFilter = state[filterName].map((f) => {
                if (f.entity_id === d) return { ...f, is_active: f.is_active === 1 ? 0 : 1, is_default: 0 };
                return f;
            });
            let filterSettingsUpdated = { ...state.filterSettingsUpdated, status: true };
            if (filterSettingsUpdated[filterName] !== "all") filterSettingsUpdated[filterName].push(d);
            return {
                ...state,
                [filterName]: updatedFilter,
                filterSettingsUpdated,
            };
        }

        case UPDATE_SETTING_UPDATED: {
            let filterSettingsUpdated = { ...state.filterSettingsUpdated, status: true };
            let { filterName, d } = action.payload;

            if (d === "all") {
                filterSettingsUpdated[filterName] = ["all"];
            } else {
                filterSettingsUpdated[filterName].push(d);
            }

            return {
                ...state,
                filterSettingsUpdated,
            };
        }

        case UPDATE_DEFAULT_SHOW_STATUS: {
            const { twitterRow, filterName } = action.payload;
            const { is_active, id } = twitterRow;
            if (is_active) {
                let filterList = state[filterName];

                filterList = state[filterName].map((row) => {
                    if (row.id === id) {
                        return { ...row, is_default: row.is_default === 1 ? 0 : 1 };
                    } else {
                        return { ...row, is_default: 0 };
                    }
                    return row;
                });

                let filterSettingsUpdated = { ...state.filterSettingsUpdated, status: true };
                if (filterSettingsUpdated[filterName] !== "all") filterSettingsUpdated[filterName].push(twitterRow);

                return {
                    ...state,
                    [filterName]: filterList,
                    filterSettingsUpdated,
                };
            } else return state;
        }
        case UPDATE_SHOW_ALL: {
            let { filterName, status } = action.payload;

            let updatedFilter = state[filterName].map((f) => {
                return { ...f, is_active: status ? 0 : 1, is_default: !status && f.is_default ? 1 : 0 };
            });
            return {
                ...state,
                [filterName]: updatedFilter,
                filterSettingsUpdated: { ...state.filterSettingsUpdated, status: true, [filterName]: ["all"] },
            };
        }
        case "SET_FILTER_LIST_FETCHED_STATUS":
            return { ...state, fetchedFiltersList: true };
        default:
            return state;
    }
};

const getFilterList = (filterList) => {
    const platformsActive = [];
    filterList.platform.forEach((x) => {
        if (x.is_active) {
            platformsActive.push({ name: x.entity_name, id: x.entity_id });
        }
    });

    const languagesActive = [];
    filterList.language.forEach((x) => {
        if (x.is_active) {
            languagesActive.push({ name: x.entity_name, id: x.entity_id });
        }
    });
    const locationsActive = [];
    filterList.location.forEach((x) => {
        if (x.is_active) {
            locationsActive.push({ name: x.entity_name, id: x.entity_id, short_name: x.short_name });
        }
    });
    const masterPublications = [];
    const publicationsActive = [];
    const publicationsActiveObject = {};
    filterList.publication.forEach((x) => {
        masterPublications.push({ name: x.entity_name, id: x.entity_id, uniqueId: x.id });
        if (x.is_active) {
            publicationsActive.push({ name: x.entity_name, id: x.entity_id, uniqueId: x.id });
            publicationsActiveObject[x.entity_id] = x.entity_name;
        }
    });

    return {
        platformsActive,
        languagesActive,
        locationsActive,
        masterPublications,
        publicationsActive,
        publicationsActiveObject,
    };
};

const getTopicsTree = (alltopics) => {
    // console.log("firsalltopicst", alltopics, "createdQueryList");

    let topicsTree = [];
    let topicsObject = {};
    let topics = [];
    alltopics = alltopics.filter((account) => !["competitor", "opa"].includes(account?.config_source?.toLowerCase()));

    alltopics.forEach((e) => {
        if (topics.indexOf(e.topic_id) == -1) {
            topics.push(e.topic_id);
        }
    });
    topics.forEach((topicid) => {
        let subtopics = alltopics.filter((sbt) => sbt.topic_id === topicid);
        topicsObject[topicid] = {
            name: subtopics[0].topic_name,
            color: subtopics[0].graph_color,
            subtopics,
            subtopicsIds: subtopics.map((s) => s.subtopic_id),
        };
        topicsTree.push({
            id: topicid,
            name: subtopics[0].topic_name,
            subtopics,
            color: subtopics[0].graph_color,
            createdDate: subtopics[0].created_date,
            dataUsageValue: subtopics.reduce((acc, current) => acc + current.data_usage_count, 0),
        });
    });
    return { topicsObject, topicsTree };
};

export default filterSettingReducer;
